<div class='body-content' (window:resize)="onResize($event)">
  <label>{{'common.availableLocations' | translate}}</label>
  @for (location of data[header]; track $index; let i = $index) {
    <div class='location-content' [ngClass]="{'last-child': i == noOfLocations}">
      @if (i < noOfLocations) {
        <div class='location-data' (click)="toggleTooltip(location)"  placement="auto" [popoverClass]="'tooltip-inner'" [ngbPopover]="popContent" container='body'> {{location.name | getIconName}}</div>
      }
      @if (i == noOfLocations) {
        <div class='location-number' (click)='showAllLocations(data)'>+{{data[header].length
        - noOfLocations}}</div>
      }
    </div>
  }
</div>

<ng-template #popContent>
  <div class='locationTooltip'>
    <div class='locationName'>{{clickedLocation.name}}</div>
    <div class='locationQoh'>
      <span class='label'>{{'common.minPar' | translate}}</span>
      <span class='dash'>-</span>
      @if (clickedLocation.hasOwnProperty('minpar')) {
        <span>{{clickedLocation.minpar | decimalFormatter}} {{unit}}</span>
      }
      @if (!clickedLocation.hasOwnProperty('minpar')) {
        <span>{{0 | decimalFormatter}}</span>
      }
    </div>
    <div class='locationQoh'>
      <span class='label'>{{'common.maxPar' | translate}}</span>
      <span class='dash'>-</span>
      @if (clickedLocation.hasOwnProperty('maxpar')) {
        <span>{{clickedLocation.maxpar | decimalFormatter}} {{unit}}</span>
      }
      @if (!clickedLocation.hasOwnProperty('maxpar')) {
        <span>{{0 | decimalFormatter}}</span>
      }
    </div>
    <div class='locationQoh'>
      <span class='label'>{{'common.qoh' | translate}}</span>
      <span class='dash'>-</span>
      <span>{{clickedLocation.qoh | decimalFormatter}} {{unit}}</span>
    </div>

  </div>
</ng-template>